module.exports = __webpack_public_path__ + "static/media/a-woman-in-a-suit.4c148b70.png";